var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 922,
    height: 1526,
    viewBox: "0 0 922 1526",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1156_316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M570.273 625.895L570.238 625.919L570.204 625.943L457.378 705.653L457.37 705.658L457.362 705.664C378.557 761.397 332.444 856.099 332.444 955.979V960.097C332.444 1030.57 385.079 1094.22 458 1094.22C530.921 1094.22 583.556 1030.57 583.556 960.097V955.979C583.556 943.924 589.214 934.122 596.117 929.184C596.132 929.173 596.147 929.162 596.162 929.151L708.872 849.525L708.903 849.502L708.935 849.48C818.125 772.024 883 640.318 883 500.076V489.487C883 263.123 715.4 73 500.778 73H415.222H415.191L415.16 73C200.602 73.3339 33 263.399 33 489.782C33 560.257 85.635 623.903 158.556 623.903C231.476 623.903 284.111 560.257 284.111 489.782C284.111 404.367 346.441 341.538 415.222 341.538H500.778C569.559 341.538 631.889 404.367 631.889 489.782V500.37C631.889 552.559 607.689 599.578 570.273 625.895ZM458 1471C498.271 1471 536.022 1453.37 563.22 1423.45C590.303 1393.65 604.944 1353.99 604.944 1313.35C604.944 1272.7 590.303 1233.04 563.22 1203.25C536.022 1173.33 498.271 1155.7 458 1155.7C417.729 1155.7 379.978 1173.33 352.78 1203.25C325.697 1233.04 311.056 1272.7 311.056 1313.35C311.056 1353.99 325.697 1393.65 352.78 1423.45C379.978 1453.37 417.729 1471 458 1471Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 80
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1156_316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 922,
    height: 1526,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.637d576ccc94283c7e839b496a9c9a43.svg";
export { ForwardRef as ReactComponent };